import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from 'state/modal/modalSlice';
import { removeGroup } from 'state/fence/fenceSlice';
import { getItemIndexById } from 'helpers/utils';
import ModalBase from 'components/common/ModalBase/ModalBase';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';

const ModalRemoveFenceGroup = () => {
  const dispatch = useDispatch();
  const fence = useSelector((state) => state.fence);
  const modal = useSelector((state) => state.modal);
  const currentGroupIndex = getItemIndexById(fence.groups, modal.props.id);

  const removeFenceGroupHandler = () => {
    dispatch(removeGroup(currentGroupIndex));
    dispatch(closeModal());
  };

  const cancelHandler = () => {
    dispatch(closeModal());
  };

  return (
    <ModalBase title={`${modal.props.index}. oldal törlése`}>
      <p className="text-center">Biztosan törlöd ezt a kerítés oldalt?</p>

      <div className="row">
        <div className="col-6">
          <ButtonBase color="primary" className="w-full" onClick={removeFenceGroupHandler}>
            Igen, törlöm
          </ButtonBase>
        </div>

        <div className="col-6">
          <ButtonBase className="w-full" onClick={cancelHandler}>
            Mégsem
          </ButtonBase>
        </div>
      </div>
    </ModalBase>
  );
};

export default ModalRemoveFenceGroup;
